import { injectable } from 'inversify';
import { MultipartUploadAdapter } from '@dealroadshow/file-uploader';
import evercallUrl from '@evercall/url';
import { IUploadAdapter } from './DI/interfaces';

@injectable()
export class UploadAdapter extends MultipartUploadAdapter implements IUploadAdapter {
  constructor() {
    super({ url: evercallUrl.getBaseFilesUrl() });
  }
}
